import imageCaraGane from '@/modules/JobPointOfContact/assets/specialist-cara-gane.png';
import imageDominiqueRoss from '@/modules/JobPointOfContact/assets/specialist-dominique-ross.png';
import imageEllieMaeMiddleton from '@/modules/JobPointOfContact/assets/specialist-elliemae-middleton.png';
import imageJackLongden from '@/modules/JobPointOfContact/assets/specialist-jack-longden.png';
import imageJessicaPearson from '@/modules/JobPointOfContact/assets/specialist-jessica-pearson.png';
import imageKatieLovell from '@/modules/JobPointOfContact/assets/specialist-katie-lovell.png';
import imageLouiseAnker from '@/modules/JobPointOfContact/assets/specialist-louise-anker.png';
import imageSophieSzczudlo from '@/modules/JobPointOfContact/assets/specialist-sophie-szczudlo.png';
import imageThropaHearne from '@/modules/JobPointOfContact/assets/specialist-thropa.png';
import { StaticImageData } from 'next/image';

export type SpecialistInfo = {
  name: string;
  role: string;
  phone: string;
  email: string;
  image: StaticImageData;
};

export const specialistInfo = {
  jessicaPearson: {
    name: 'Jessica Pearson',
    role: 'Executive Solutions Specialist',
    phone: '+64 3 450 9313',
    email: 'jessica.pearson@medrecruit.com',
    image: imageJessicaPearson,
  },
  louiseAnker: {
    name: 'Louise Anker',
    role: 'Senior Division Manager',
    phone: '+61 7 5553 9606',
    email: 'louise.anker@medrecruit.com',
    image: imageLouiseAnker,
  },
  dominiqueRoss: {
    name: 'Dominique Ross',
    role: 'Senior Solutions Specialist',
    phone: '+64 3 450 9314',
    email: 'dominique.ross@medrecruit.com',
    image: imageDominiqueRoss,
  },
  caraGane: {
    name: 'Cara Gane',
    role: 'Team Leader - GP Clinic Division',
    phone: '+61 75 520 9566',
    email: 'cara.gane@medrecruit.com',
    image: imageCaraGane,
  },
  elliemaeMiddleton: {
    name: 'Ellie-Mae Middleton',
    role: 'Solution Specialist - Permanent',
    phone: '+61 75 610 5019',
    email: 'elliemae.middleton@medrecruit.com',
    image: imageEllieMaeMiddleton,
  },
  sophieSzczudlo: {
    name: 'Sophie Szczudlo',
    role: 'Solutions Specialist - Junior & Registrar Division',
    phone: '+61 7 5610 5059',
    email: 'sophie.szczudlo@medrecruit.com',
    image: imageSophieSzczudlo,
  },
  thropaHearne: {
    name: 'Thropa Hearne',
    role: 'Solutions Specialist - Anaesthetics Registrar',
    phone: '+61 3 8657 5579',
    email: 'thropa.hearne@medrecruit.com',
    image: imageThropaHearne,
  },
  jackLongden: {
    name: 'Jack Longden',
    role: 'Solutions Specialist - Paediatrics Registrar',
    phone: '+61 7 5553 9613',
    email: 'jack.longden@medrecruit.com',
    image: imageJackLongden,
  },
  katieLovell: {
    name: 'Katie Lovell',
    role: 'Solutions Specialist - Psychiatry Registrar',
    phone: '+61 7 5610 5057',
    email: 'katie.lovell@medrecruit.com',
    image: imageKatieLovell,
  },
};
